import React, { useState } from 'react';
import { InputAdornment, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TextfieldInput from '@_components/TextfieldInput/TextfieldInput';
import makeStyles from '@mui/styles/makeStyles';

function PasswordField(props) {
  const [showPassword, togglePassword] = useState(false);
  const handleClickShowPassword = () => {
    togglePassword(!showPassword);
  };

  const useStyles = makeStyles({
    IconButton: { width: '50px' },
  });

  const classes = useStyles();

  return (
    <TextfieldInput
      {...props}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              className={classes.IconButton}
              size="large">
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

export default PasswordField;
